/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  max-width: 600px;
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  gap: 20px;
  border-radius: 20px;
  background-color: ${({ theme }) => `${theme.colors.white}`};
  border: 1px solid ${({ theme }) => `${theme.colors.lightGray}`};
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
`

export const AddressVerificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ correctWallet }) => (correctWallet ? 'flex-start' : 'center')};
  justify-content: ${({ correctWallet }) => (correctWallet ? 'flex-start' : 'center')};
  padding: ${({ correctWallet }) => (correctWallet ? '20px' : '120px 20px')};

  width: 100%;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => `${theme.colors.gray}60`};
`

export const AddressVerificationContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ connected }) => (connected ? 'column-reverse' : 'column')};
  justify-content: ${({ connected }) => (connected ? 'flex-start' : 'center')};
  gap: ${({ connected }) => (connected ? '10px' : '20px')};

  position: relative;

  width: 100%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  /* background-color: ${({ theme }) => theme.colors.lightGray}; */
  border: ${({ theme }) => `1px solid ${theme.colors.gray}60`};
  ${({ connected }) =>
    connected
      ? `padding: 8px 15px;
      border-radius: 12px;
      cursor:pointer;`
      : `padding: 15px;
      border-radius: 20px;`}
  &:hover {
    ${({ connected, theme }) =>
      connected && `background-color: ${theme.colors.blue}30; border: 1px solid ${theme.colors.blue};`}
  }
  transition: 0.5s;
`

export const AddressContainer = styled.div`
  font-size: 14px;

  color: ${({ theme }) => theme.colors.darkGray};

  transition: 0.5s;
  overflow: hidden;

  ${({ connected }) =>
    connected ? 'width: auto; padding: 5px 10px;  position: relative;' : 'width: 0; padding: 0; position: absolute;'}
`
export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  transition: 0.5s;
`

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.lightGray};
  border: ${({ theme }) => `1px solid ${theme.colors.gray}60`};
  margin: 20px 0;
`
export const Text = styled.div`
  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.darkGray)};
  font-size: 14px;
  text-align: center;
  margin: 0;

  transition: 0.5s;
`
export const Title = styled.div`
  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.darkGray)};
  font-size: 24px;
  font-weight: 700;
  text-align: center;

  margin: 0;

  transition: 0.5s;
`
